import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DishCreateAllergensPage } from "../../dish-create/dish-create-allergens/dish-create-allergens";
import { Globals } from '../../../../globals';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view-allergens',
    templateUrl: 'dish-view-allergens.html',
})
export class DishViewAllergensPage {
    @Input() dish: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {
    }

    edit() {
        this.navCtrl.push(DishCreateAllergensPage, {
            update: true,
            dish_uid: this.dish.UID,
            allergens: this.dish.allergens,
            dish_name: this.globals.nameLangSelectDish(this.dish),
            dish: this.dish
        })
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-allergens/dish-view-allergens.ts